import Error from './Error.vue';

const routes = [
  {
    path      : '/error',
    name      : 'Error',
    component : Error,
    props     : true,
    meta      : {
      isPublic: true
    }
  }
];

export default routes;
